<template>
  <div>
    <el-button type="text" @click="openBatchAdd">
      <i class="el-icon el-icon-plus"></i>
      {{ btnName }}
    </el-button>
    <el-dialog destroy-on-close width="40%" :visible.sync="batchAddOpen">
      <template slot="title">
        <div class="dialog-title">批量添加</div>
      </template>
      <div class="mate-wrap" v-if="matchsNum.province || matchsNum.city">匹配省份/直辖市{{matchsNum.province}}个，城市{{matchsNum.city}}个</div>
      <el-form-item class="box" :label="label" label-width="120">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 7 }" :placeholder="placeholder" v-model="batchValue" @input="regionQueryHandle" placeholder="不同省/市可通过英文逗号、空格或顿号隔开，支持城市级别精准输入" />
<!--        <el-input v-model="batchValue" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" :placeholder="placeholder"></el-input>-->
      </el-form-item>
      <div v-if="matchsNum.province || matchsNum.city">已匹配：{{mateRegion}}</div>
      <div slot="footer" class="footer-btns">
        <el-button @click="batchAddOpen = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from 'lodash'
export default {
  props: {
    btnName: { type: String, default: '批量添加' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '请输入内容，用中/英文逗号隔开' }
  },
  data() {
    return {
      // 公式
      regionList: [],
      mateRegion: '',
      matchsNum: {
        province: 0,
        city: 0
      },
      batchValue: '',
      batchAddOpen: false
    }
  },
  methods: {
    regionQueryHandle: debounce(function (e) {
      const parmas = {
        content: this.batchValue
      }
      if (!parmas.content) {
        this.regionList = []
        this.matchsNum.province = ''
        this.matchsNum.city = ''
        return
      }
      this.$service.getNlpRegion(parmas).then(res => {
        if (res) {
          let resData = res || []
          this.regionList = resData
          this.matchsNum.province = resData.filter(item => item.parent === 0).length
          this.matchsNum.city = resData.filter(item => item.parent !== 0).length
          this.mateRegion = this.regionList.map(item => item.name).join()
        }
      })
    }, 1000),
    openBatchAdd() {
      Object.assign(this.$data, this.$options.data())
      this.batchAddOpen = true
    },
    handleSave() {
      this.$emit('save-add', this.regionList)
    }
  }
}
</script>

<style lang="stylus" scoped>
.box.el-form-item {
   margin 0!important
}
.mate-wrap {
  position absolute
  right 20px
  top 65px
  text-align right
  font-size 14px
}
.dialog-title
  border-bottom 1px solid #eee
.footer-btns
  text-align center
  .el-button
    margin-right 20px
</style>
